export interface ResolvedFn<T = any> {
  (val: T): T | Promise<T>;
}

export interface RejectedFn<T = any> {
  (error: T): Promise<T>;
}

interface Interceptor<T, U> {
  resolved: ResolvedFn<T>;
  rejected?: RejectedFn<U>;
}

export class InterceptorManager<T, U = any> {
  interceptors: Array<Interceptor<T, U> | null>;

  constructor() {
    this.interceptors = [];
  }

  use(resolved: ResolvedFn<T>, rejected?: RejectedFn<U>): number {
    this.interceptors.push({
      resolved,
      rejected,
    });
    return this.interceptors.length - 1;
  }

  eject(id: number): void {
    if (this.interceptors[id]) {
      this.interceptors[id] = null;
    }
  }
}
